import moment from "moment";

const DEFAULT_BRAZILIAN_FORMAT = "DD/MM/YYYY";
const DEFAULT_BRAZILIAN_DATE_TIME_FORMAT = `${DEFAULT_BRAZILIAN_FORMAT} HH:mm:ss`;
const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
const DEFAULT_MAIORIDADE = 18;

const currentDate = moment().format(DEFAULT_BRAZILIAN_DATE_TIME_FORMAT);

const currentDateWithoutTime = (format = DEFAULT_DATE_FORMAT) =>
  moment().format(format);

const formatDate = (
  date,
  destinationFormat = DEFAULT_BRAZILIAN_FORMAT,
  originFormat = DEFAULT_DATE_FORMAT
) =>
  moment(date, originFormat).isValid()
    ? moment(date, originFormat).format(destinationFormat)
    : "";

const formatDateRestore = date =>
  formatDate(date, DEFAULT_DATE_FORMAT, DEFAULT_BRAZILIAN_FORMAT);

const isMenorDeIdade = dataNascimento => {
  const nascimento = moment(dataNascimento, DEFAULT_DATE_FORMAT);
  const idade = moment().diff(nascimento, "years");

  return idade < DEFAULT_MAIORIDADE;
};

export {
  DEFAULT_BRAZILIAN_DATE_TIME_FORMAT,
  currentDate,
  currentDateWithoutTime,
  formatDate,
  formatDateRestore,
  isMenorDeIdade
};
